import React from 'react'
import { shape, string, object, number, func, bool } from 'prop-types'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router'
import moment from 'moment'

import { ProfilePicture } from '../../../components/ui/ProfilePicture'
import { Price } from '../../../components/ui/inputs/Price'
import { CancellationButton } from '../../../components/ui/buttons/CancellationButton'
import { PagesPaths } from '../../../constants/Pages'
import { ProposalStatus } from '../../../constants/ProposalStatus'

export const ProposalsAccepted = withRouter(translate()(({ proposal, t, payment, history, avanceImmediateEnabled }) => (
  <div className='demandes__section'>
    <div className='demandes__third'>
      <div>
        <ProfilePicture size={120} picture={proposal.profilePicture} className='img--avatar' alt='picture' />
      </div>
      <div style={{ margin: '0 40px' }}>
        <p>
          {t('common:visits:payment_prestation_message_first_1')} <span className='bold'>{proposal.name}</span> {t('common:visits:payment_prestation_message_first_2')}
          <br />
          le <span className='bold'>{ moment.unix(proposal.date).format('DD/MM/YYYY') } { t('common:visits:payment_prestation_message_at') } { moment.unix(proposal.date).format('HH:mm') } { t('common:visits:payment_prestation_message_first_3') } {moment.duration(proposal.duration * 1000).hours()} h {moment.duration(proposal.duration * 1000).minutes()} min</span>
        </p>
        {
          payment.unpaid > 0.0
          ? <UnpaidMessage payment={payment} avanceImmediateEnabled={avanceImmediateEnabled} />
          : <span>Prestation <span className='bold'>payée (<Price value={payment.total} />)</span>.</span>
        }
      </div>
      <div>
        <a className='btn--green' target='_blank' href={proposal.quotation.path}>{t('common:visits:read_invoice')}</a>
        <a className='btn--green' target='_blank' href={proposal.quotation.path + '&download=true'}>{t('common:visits:download_invoice')}</a>
      </div>
    </div>
    <CancellationButton
      id={proposal.id}
      style={{ margin: '20px auto 20px auto' }}
      onCancel={() => proposal.status === ProposalStatus.ACCEPTED && history.push(PagesPaths.INQUIRIES.path)} />
    <p className='paragraph--centered paragraph'>
      *En cas d'annulation, vous serez remboursé de la prestation.<br />
      Une pénalité pourra être appliquée en cas d'annulation moins de 72h avant la prestation ou la visite.<br />
      Vous pouvez contacter notre service client au 0189711870.
    </p>
  </div>
)))

const UnpaidMessage = ({ payment, avanceImmediateEnabled }) => {
  if (avanceImmediateEnabled) {
    return <div>
      <div>
        <span>Prestation <span className='bold'>partiellement payée (<Price value={payment.paid} />)</span>, vous serez débité du reste <span className='bold'>(<Price value={payment.total * 0.2} />)</span> à la fin de la prestation par l’Urssaf si votre compte <span className='bold'>Avance immédiate</span> est bien activé et que Cmonjardinier apparait bien dans vos bénéficiaires.</span>
      </div>
      <div>
        <span>Si votre compte <span className='bold'>Avance immédiate</span> ne fonctionne pas, vous devrez payer les <span className='bold'><Price value={payment.total - payment.paid} /></span> restants dès la fin de la prestation directement à Cmonjardinier.</span>
      </div>
    </div>
  } else {
    return <span>Prestation <span className='bold'>partiellement payée (<Price value={payment.paid} />)</span>, vous serez débité du reste <span className='bold'>(<Price value={payment.unpaid} />)</span> à la fin de la prestation.</span>
  }
}

ProposalsAccepted.propTypes = {
  proposal: shape({
    id: string,
    profilePicture: object,
    name: string,
    date: number,
    duration: number,
    maintenance: shape({
      nbHours: number
    })
  }),
  payment: shape({
    advance: number,
    unpaid: number,
    total: number,
    paid: number,
    balance: number
  }),
  history: object,
  avanceImmediateEnabled: bool,
  t: func
}



// WEBPACK FOOTER //
// ./src/pages/demandes/realisations/ProposalsAccepted.js